module.exports = __webpack_public_path__ + "img/nl_Ecran 3.bfa5aba1.png";